<template>
	<div class="evaluation">
		<headerTemplate title="教学评估"></headerTemplate>
		<div class="evaluation-group">
			<div class="evaluation-wapper">
				<div class="evaluation-item">
					<span class="evaluation-item-label">用户姓名:</span>
					<span class="evaluation-item-content">{{firstRes.alog_store_name}}</span>
				</div>
				<div class="evaluation-item">
					<span class="evaluation-item-label">上次考试成绩:</span>
					<span class="evaluation-item-content">{{firstRes.score}}</span>
				</div>
				<div class="evaluation-item">
					<span class="evaluation-item-label">最好考试成绩:</span>
					<span class="evaluation-item-content">{{firstRes.high_score}}</span>
				</div>
				<div class="evaluation-item">
					<span class="evaluation-item-label">作答次数:</span>
					<span class="evaluation-item-content">{{firstRes.answer_num}}</span>
				</div>
				<div class="evaluation-item">
					<span class="evaluation-item-label">最后答题时间:</span>
					<span class="evaluation-item-content">{{showDate(firstRes.edit_time)}}</span>
				</div>
				<div class="evaluation-item">
					<span class="evaluation-item-label">当前状态:</span>
					<span class="evaluation-item-content">{{firstRes.message}}</span>
				</div>
			</div>
			<!-- 选择题 -->
			<!-- <div class="single-choice" v-if="firstRes.status == 0"> -->
			<div class="single-choice">
				<div class="single-title">一.单项选择题</div>
				<div class="single-choice-item" v-for="(item, i) in firstResSingle" :key="i">
					<div class="question-title">{{item.num}}、{{item.question_title}}</div>
					<van-radio-group v-model="single[i]">
						<van-radio v-for="(q,t) in item.chose" :key="t" :disabled="finishSta ? true : false"
							:name="item.question_id + ',' + q.chose_num">{{q.chose_id}} {{q.chose}}</van-radio>
					</van-radio-group>
					<div v-if="finishSta" class="answer-wapper">
						<div class="right-answer" v-if="single[i] && item.answer == single[i].substr(-1)">
							<span>回答正确：
								<van-icon name="success" size="20px" color="#2f9afb" />
							</span>
						</div>
						<div class="wrong-answer" v-else>
							<p>回答错误：
								<van-icon name="cross" color="#ff0000" />
							</p>
							<p>您的答案：<span>{{ toLetter1(single[i].substr(-1)) }}</span></p>
							<p>正确答案是：<span style="color: #ff0000;">{{ toLetter1(item.answer) }}</span></p>
						</div>
					</div>
				</div>
			</div>
			<!-- <pre>
				{{firstResSingle}}
			</pre> -->
			<div class="submit" v-if="firstRes.status == 0">
				<!-- <van-button v-if="finishSta" type="info" size="small" @click="changeFinishSta">
					在做一次</van-button> -->
				<van-button type="info" size="small" @click="submitPaper">交卷</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { Notify } from 'vant';
	import { getEvaluation, evaluationSubmitPaper } from '../../../api/student'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'Evaluation',
		components: {
			headerTemplate
		},
		props: [],
		data() {
			return {
				// 显示状态-做卷时or完成试卷
				finishSta: false,
				// 单项选择
				single: [],
				// 当前试卷的id
				paperId: 1,
				// 第一次作答
				firstRes: [],
				// 第一次作答-单项选择题
				firstResSingle: []
			}
		},
		methods: {
			showDate(time) {
				if (!time) {
					return ""
				}
				return new Date(time * 1000).toLocaleString()
			},
			goBack() {
				this.$router.go(-1)
			},
			toLetter1(answer) {
				let letters = ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G']
				return letters[answer]
			},
			// 改变做卷状态
			changeFinishSta() {
				this.finishSta = !this.finishSta
			},
			getEvaluation() {
				getEvaluation().then(res => {
					if (res.code === 10000) {
						this.firstRes = res.result
						// this.firstRes.status = 0

						if (!res.result.paper) {
							return false
						}
						// 试卷id
						this.paperId = res.result.paper_id
						// 单项选择题
						let num = 0;
						let lists = res.result.paper.single || []
						lists.map((item) => {
							num += 1;
							item.num = num
							return item
						})
						this.firstResSingle = lists;
						if (res.result.status > 0) {
							this.finishSta = true
							const answer = JSON.parse(res.result.answer)
							this.single = this.strToArr(answer.single)
						}
					}
				})
			},
			// 交卷
			submitPaper() {


				let ar = []
				this.single.forEach(element => {
					if (element) {
						ar.push(element)
					}
				});



				// return false
				evaluationSubmitPaper({
					paper_id: this.paperId,
					single: ar.toString()
				}).then(res => {

					// this.getEvaluation()
					// this.changeFinishSta()
				}).catch(error => {
					alert(error.message)
				})
			},
			strToArr(str) {
				let arr = str.split(',')
				let res = []
				for (let i = 0; i < arr.length; i += 2) {
					res.push(arr[i] + ',' + arr[i + 1])
				}
				return res
			}
		},
		created() {
			this.getEvaluation()
		}
	}
</script>

<style lang="scss" scoped>
	.evaluation {
		font-size: 14px !important;

		.evaluation-title {
			display: flex;
			align-items: center;
			color: white;
			background: #2f9afb;

			.title {
				padding: 10px;
			}
		}

		.evaluation-group {
			.evaluation-wapper {
				box-shadow: 0 0 5px #bbb7b7;
				margin: 5px 10px 10px 10px;

				.evaluation-item {
					padding: 5px;
					display: flex;
					justify-content: flex-start;
					border-bottom: 1px solid #E0E0E0;

					.evaluation-item-label {
						text-align-last: right;
						margin-right: 5px;
						font-weight: bold;
					}
				}
			}

			.single-choice {
				padding-bottom: 5rem;

				.single-title {
					background-color: #2f9afb;
					color: white;
					padding: 10px;
					margin: 10px
				}

				.single-choice-item {
					margin: 10px;
					padding: 5px 10px;
					box-shadow: 0 0 5px #bbb7b7;
				}
			}

			.submit {
				margin-left: 10px;
			}
		}

		.evaluation-group   ::v-deep.van-radio-group {
			margin: 10px 0;

			.van-radio:not(:last-child) {
				margin-bottom: 5px;
			}
		}
	}
</style>